/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { PostService } from '../../../../core/posts/post.service';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import * as moment from 'moment';
import { ConfigService } from '../../../../core/service/config.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../core/common/common.service';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit, OnDestroy {
	public imagePath: string = '';
	public postFormEmail: FormGroup;
	@ViewChild('scrollMeFooter') private myScrollContainer: ElementRef;

	constructor(public listSandbox: ListsSandbox, public commonSandbox: CommonSandbox, public postService: PostService,
		public configService: ConfigService,
		public commonService: CommonService,
		public route: ActivatedRoute,
		@Inject(PLATFORM_ID) private platformId: Object,
		public router: Router,
		private formBuilder: FormBuilder,
	) { }
	public profile: any = null;
	public offset = 0;
	public loading = true;
	public posts = [];
	public socket;

	public subscriptions = [];

	public vendor: any = null;

	public siteSetting = null;

	public captchaError = 0;
	public dataa: any = [
		{
			"parentName": "About Us",
			"childProperties":
				[
					{ "propertyName": "About Us" },
				]
		}
	];
	public dataa2: any = [
		{
			"parentName": "Premier Streets",
			"childProperties":
				[
					{ "propertyName": "Premier Streets" },
				]
		}
	];
	public dataa3: any = [
		{
			"parentName": "Contact",
			"childProperties":
				[
					{ "propertyName": "Contact" },
				]
		}
	];

	ngOnInit() {
		this.postFormEmail = this.formBuilder.group({
			email: ['', [Validators.email, Validators.required]],
			myRecaptcha: ['', [Validators.required]]
		});

		this.imagePath = this.configService.getImageUrl();
		const params: any = {};
		params.limit = '';
		params.offset = 0;
		params.keyword = '';
		this.listSandbox.getPageList(params);

		if (isPlatformBrowser(this.platformId)) {
			this.profile = JSON.parse(localStorage.getItem('storeUser'));
		}

		this.commonService.getSiteSetting().toPromise().then((response: any) => {
			this.siteSetting = response.data;
			this.commonSandbox.setSiteSettings(this.siteSetting);
		})

		this.subscriptions.push(this.commonSandbox.customerLogOut$.subscribe(status => {
			if (status) {
				this.profile = null;
			}
		}));

		this.subscriptions.push(this.commonSandbox.vendorDetail$.subscribe((vendor: any) => {
			if (vendor) {
				this.vendor = vendor;
			}
		}));
	}

	// dowload link for mobile app
	downloadApp() {
		window.open('https://play.google.com/store/apps/details?id=com.premierstreets.premierstreets');
	}

	openLink(link) {
		window.open(link);
	}

	goToSocial() {
		this.router.navigate(['socialhub-user'])
	}

	formatDate(date) {
		return moment(date).format('hh.mm a, MMMM DD YYYY')
	}

	scrollToBottom(): void {
		try {
			this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
		} catch (err) {
		}
	}



	ngOnDestroy() {
		if (this.socket) {
			this.socket.disconnect();
		}
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			}
		});
	}


	toggleAccordian(event, index) {
		var element = event.target;
		element.classList.toggle("active");
		if (this.dataa[index].isActive) {
			this.dataa[index].isActive = false;
		} else {
			this.dataa[index].isActive = true;
		}
		var panel = element.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + "px";
		}
	}


	submit() {
		console.log("this.postFormEmail.valid");
		console.log(this.postFormEmail.valid);
		if (!this.postFormEmail.valid) {
			this.validateAllFormFields(this.postFormEmail);
			this.captchaError = 1;
			return;
		}
		this.captchaError = 0;
		this.commonService.addNewsletter({
			email: this.postFormEmail.controls['email'].value,
			vendorId: this.siteSetting.vendorId
		}).toPromise().then((response) => {
			this.postFormEmail.reset();
		}, (err) => {

		})
	}


}
